/* unplugin-vue-components disabled */import { render } from "./c-now.vue?vue&type=template&id=1ec40374&scoped=true"
import script from "./c-now.vue?vue&type=script&lang=js"
export * from "./c-now.vue?vue&type=script&lang=js"

import "./c-now.vue?vue&type=style&index=0&id=1ec40374&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ec40374"]])

export default __exports__